var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navh'),_c('top',{attrs:{"image":_vm.$route.fullPath.substr(0,6)==='/'}}),_c('main',[_c('router-view')],1),_c('foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }